import { useAppSelector, useAppDispatch } from '../reduxProvider'
import { ModulesStatus, Settings } from './types'
import { setSettings, setModulesStatus, setModulesStatusLoaded } from './store'

const MODULE_CODE = 'Common'
const BFF_CODE = 'TenantAdminBff'
const IDENTITY_CODE = 'IdsWeb'

const useSettings = () => {
  const dispatch = useAppDispatch()
  const { settings, modulesStatus } = useAppSelector((state) => state.settings)

  const fetchSettings = async () => {
    const settingsResponse = await fetch('/api/v1/settings')
    const appSettings: Settings = await settingsResponse.json()
    const isTenant = location.pathname.split('/')[1] === 't'
    if (isTenant) {
      const tenantid = location.pathname.split('/')[2]
      await fetchModulesStatus(tenantid, appSettings)
      await setInitialUrls(tenantid, appSettings)
    } else {
      dispatch(setSettings(appSettings))
    }
  }

  const fetchModulesStatus = async (
    tenantId: string,
    appSettings?: Settings
  ) => {
    dispatch(setModulesStatusLoaded(false))
    const mySettings = appSettings || settings
    if (!mySettings) return { moduleStatus: false, tenantStatus: false }
    const response = await fetch(
      `${mySettings.saasBff.url}/tenants/${tenantId}/modules/${MODULE_CODE}`
    )
    const moduleStatus: ModulesStatus = await response.json()
    dispatch(setModulesStatus(moduleStatus))
    dispatch(setModulesStatusLoaded(true))
  }

  const setInitialUrls = async (tenantId: string, appSettings?: Settings) => {
    const mySettings = (appSettings || settings) as Settings
    const response = await fetch(
      `${mySettings?.saasBff.url}/tenants/${tenantId}/urls/all`
    )
    const urlsArr = await response.json()
    const bffUrl = urlsArr.filter(
      (item: Record<string, string>) => item.code === BFF_CODE
    )[0].url
    const identityUrl = urlsArr.filter(
      (item: Record<string, string>) => item.code === IDENTITY_CODE
    )[0].url
    dispatch(
      setSettings({
        ...mySettings,
        bff: { url: `${bffUrl}/api/v1` },
        identity: { ...mySettings.identity, authority: identityUrl },
      })
    )
  }

  return {
    settings: settings,
    fetchSettings,

    fetchModulesStatus,
    modulesStatus,

    setInitialUrls,
  }
}

export default useSettings
